import { render } from "./DbSavePropsCmp.vue?vue&type=template&id=e357d9aa"
import script from "./DbSavePropsCmp.vue?vue&type=script&lang=js"
export * from "./DbSavePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__